import React from "react";
import Phonetic from "./Phonetic";
import Meaning from "./Meaning";
import "./Results.css";

export default function Results(props) {
    //if we do have results (of the API)
   if (props.results) {
        return (
            <div className="Results">
                <section>
                    {/* h2 with the word = the key word */}
                    <h2>{props.results.word}</h2>
                    {/* looking through an array of phonetics */}
                    {props.results.phonetics.map(function (phonetic, index) {
                        // return every phonetic of the word
                        return (
                            <div key={index}>
                                {/* creating a component for each phonetic */}
                                <Phonetic phonetic={phonetic} />
                            </div>
                        );
                    })}
                </section>
                {/* looking through an array of meanings */}
                {props.results.meanings.map(function (meaning, index) {
                    // return every meaning of the word
                    return (
                        <section key = {index}>
                            {/* creating a component for each meaning */}
                            <Meaning meaning={meaning} />
                        </section>
                    );
                })}
            </div>
        );
    //if we do not have results, do nothing
    } else {
        return null;
    }
}